import angular from 'angular';

angular
  .module('cloudX')
  .filter('regTaskName', ['translateListFilter', '$translate', 'dataCache', regTaskName]);

function regTaskName(translateListFilter, $translate, dataCache) {
  return function(item) {
    if (!item || !item.plannedTaskId) return '';
    let taskName = item.plannedTaskName || '';

    if (!taskName && item.plannedTaskTemplateId) {
      taskName = translateListFilter(item.plannedTaskTemplateId, 'taskTemplate');
      if (!taskName) {
        const defaultTenantLangauge =
          dataCache.getArray('language').find(x => x.isDefault)?.culture ?? 'nl-be';
        const currentLanguage = $translate.use().split('-')[0];
        const translatedInTenantLanguageTaskName = translateListFilter(
          item.plannedTaskTemplateId,
          'taskTemplate',
          null,
          null,
          defaultTenantLangauge,
        );

        taskName = $translate.instant('{{task}} is not translated in {{lang}}', {
          task: translatedInTenantLanguageTaskName,
          lang: currentLanguage,
        });
      }
    }

    if (!item.mainPlannedTaskId || item.mainPlannedTaskId === item.plannedTaskId) {
      return taskName;
    }

    let mainTaskName = item.mainPlannedTaskName || '';
    if (!mainTaskName && item.mainTaskTemplateId) {
      mainTaskName = translateListFilter(item.mainTaskTemplateId, 'taskTemplate');
    }

    return mainTaskName ? `${mainTaskName} - ${taskName}` : taskName;
  };
}
